/**
 * Utility functions for formatting numbers, dates, etc. (Solana Dice)
 */
const LAMPORTS_PER_SOL = 1_000_000_000;

export const formatSats = (n) => {
  return new Intl.NumberFormat().format(n);
};

/** Format lamports as number (same as formatSats, for compatibility) */
export const formatLamports = (lamports) => {
  return new Intl.NumberFormat().format(lamports);
};

/** Format SOL amount (e.g. 0.01, 1.5) */
export const formatSOL = (sol) => {
  if (sol == null || isNaN(sol)) return '0';
  return Number(sol).toFixed(4).replace(/\.?0+$/, '') || '0';
};

/** @deprecated Use formatSOL */
export const formatBTC = (sol) => formatSOL(sol);

export const formatUSD = (usd) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(usd ?? 0);
};

export const formatPercent = (percent) => {
  return `${Number(percent).toFixed(2)}%`;
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleString();
};

export const formatDateShort = (dateString) => {
  return new Date(dateString).toLocaleDateString();
};

/** Convert lamports to SOL */
export const lamportsToSOL = (lamports) => {
  return (lamports ?? 0) / LAMPORTS_PER_SOL;
};

/** @deprecated Use lamportsToSOL */
export const satsToBTC = (n) => lamportsToSOL(n);

export const LAMPORTS_PER_SOL_CONST = LAMPORTS_PER_SOL;
